import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import FormWizard from "react-form-wizard-component";
import "react-form-wizard-component/dist/style.css";
import * as Yup from "yup";
import { useFormik } from "formik";

// class AddApplicant extends React.Component {
function AddApplicant() {
  const [uploadResume, setUploadResume] = useState(false);
  const [socialMedia, setSocialMedia] = useState(false);

  useEffect(() => {}, []);

  //   render() {
  const handleComplete = () => {};
  const tabChanged = ({ prevIndex, nextIndex }) => {};

  const addMoreDetail = (page) => {
    if (page == 1) {
      setUploadResume(true);
    }
    if (page == 2) {
      setSocialMedia(true);
    }
  };

  const ValidationSchema = Yup.object().shape({
    basicInfo: Yup.string().required("Basic info is required."),
    mobile: Yup.string().matches(/^[0-9]{10}$/, "Mobile number must be 10 digits").required("Mobile number is required."),
    email: Yup.string().required("Email is required."),
    companyName: Yup.string().required("Company name is required."),
    profile: Yup.string().required("Profile is required."),
    currentCTC: Yup.string().required("Current CTC is required."),
    expectedCTC: Yup.string().required("Expected CTC is required."),
    overallExperience: Yup.string().required("Overall Experience is required."),
    relevantExperience: Yup.string().required(
      "Relevant Experience is required."
    ),
    noticePeriod: Yup.string().required("Notice Period is required."),
  });

  const addApplicantForm = useFormik({
    initialValues: {
      basicInfo: "",
      mobile: "",
      email: "",
      companyName: "",
      profile: "",
      currentCTC: "",
      expectedCTC: "",
      overallExperience: "",
      relevantExperience: "",
      noticePeriod: "",
    },
    validationSchema: ValidationSchema,
    onSubmit: async (data) => {
      let req = {};
      try {
      } catch (error) {}
    },
  });

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      {/* <!-- row --> */}
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-10 shrink-w">
            <div className="form-head d-flex flex-wrap align-items-center mb-3">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">Add Applicant</h2>
                <p className="text-light">Lorem ipsum dolor sit amet</p>
              </div>
              <div className="rightside-tabs">
                <Link to="RecruitmentDashboard">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="currentColor"
                    className="bi bi-arrow-left-short"
                    viewBox="0 0
 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12 8a.5.5 0 0 1-.5.5H5.7
 07l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5
 .5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                    ></path>
                  </svg>
                </Link>
              </div>
            </div>
            {!uploadResume && !socialMedia && (
              <form onSubmit={addApplicantForm.handleSubmit}>
                <div className="row">
                  <div className="col-xl-10">
                    <div className="col-xl-12">
                      <div className="supp-req">
                        <div className="addcourseform">
                          <span className="tagtitle">Basic Info</span>
                          <div className="row">
                            <div className="mb-4 col-md-12">
                              <input
                                type="text"
                                cols="1"
                                rows="4"
                                name="basicInfo"
                                value={addApplicantForm.values.basicInfo}
                                onChange={addApplicantForm.handleChange}
                                className={
                                  "form-control bg-chng" +
                                  (addApplicantForm.errors.basicInfo &&
                                  addApplicantForm.touched.basicInfo
                                    ? " is-invalid"
                                    : "")
                                }
                                placeholder="Applicant Name goes here..|"
                              />
                              <div className="invalid-feedback">
                                {addApplicantForm.errors.basicInfo &&
                                addApplicantForm.touched.basicInfo
                                  ? addApplicantForm.errors.basicInfo
                                  : null}
                              </div>
                            </div>

                            <div className="mb-4 col-md-6">
                              <label className="form-label">
                                Mobile Number
                              </label>
                              <div className="cover-form">
                                <div>
                                  <i
                                    className="fa fa-money"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                                <input
                                  type="number"
                                  name="mobile"
                                  // maxLength={10}
                                  className={
                                    "form-control" +
                                    (addApplicantForm.errors.mobile &&
                                    addApplicantForm.touched.mobile
                                      ? " is-invalid"
                                      : "")
                                  }
                                  value={addApplicantForm.values.mobile}
                                  onChange={addApplicantForm.handleChange}
                                />
                              </div>
                              <div className="invalid-feedback">
                                {addApplicantForm.errors.mobile &&
                                addApplicantForm.touched.mobile
                                  ? addApplicantForm.errors.mobile
                                  : null}
                              </div>
                            </div>
                            <div className="mb-4 col-md-6">
                              <label className="form-label">
                                Email Address
                              </label>
                              <div className="cover-form">
                                <div>
                                  <i
                                    className="fa fa-money"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                                <input
                                  type="email"
                                  name="email"
                                  className={
                                    "form-control" +
                                    (addApplicantForm.errors.email &&
                                    addApplicantForm.touched.email
                                      ? " is-invalid"
                                      : "")
                                  }
                                  value={addApplicantForm.values.email}
                                  onChange={addApplicantForm.handleChange}
                                />
                              </div>
                              <div className="invalid-feedback">
                                {addApplicantForm.errors.email &&
                                addApplicantForm.touched.email
                                  ? addApplicantForm.errors.email
                                  : null}
                              </div>
                            </div>
                            <div className="mb-4 col-md-6">
                              <label className="form-label">Company Name</label>
                              <div className="cover-form">
                                <div>
                                  <i
                                    className="fa fa-money"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                                <input
                                  type="text"
                                  name="companyName"
                                  className={
                                    "form-control" +
                                    (addApplicantForm.errors.companyName &&
                                    addApplicantForm.touched.companyName
                                      ? " is-invalid"
                                      : "")
                                  }
                                  value={addApplicantForm.values.companyName}
                                  onChange={addApplicantForm.handleChange}
                                />
                              </div>
                              <div className="invalid-feedback">
                                {addApplicantForm.errors.companyName &&
                                addApplicantForm.touched.companyName
                                  ? addApplicantForm.errors.companyName
                                  : null}
                              </div>
                            </div>
                            <div className="mb-4 col-md-6">
                              <label className="form-label">Profile</label>
                              <div className="cover-form">
                                <div>
                                  <i
                                    className="fa fa-bookmark-o"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                                <select
                                  id="inputState"
                                  name="profile"
                                  className={
                                    "default-select form-control wide" +
                                    (addApplicantForm.errors.profile &&
                                    addApplicantForm.touched.profile
                                      ? " is-invalid"
                                      : "")
                                  }
                                  value={addApplicantForm.values.profile}
                                  onChange={addApplicantForm.handleChange}
                                >
                                  <option selected="">Choose...</option>
                                  <option>Option 1</option>
                                  <option>Option 2</option>
                                  <option>Option 3</option>
                                </select>
                              </div>
                              <div className="invalid-feedback">
                                {addApplicantForm.errors.profile &&
                                addApplicantForm.touched.profile
                                  ? addApplicantForm.errors.profile
                                  : null}
                              </div>
                            </div>
                            <div className="mb-4 col-md-6">
                              <label className="form-label">Current CTC</label>
                              <div className="cover-form">
                                <div>
                                  <i
                                    className="fa fa-money"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                                <input
                                  type="number"
                                  name="currentCTC"
                                  className={
                                    "form-control" +
                                    (addApplicantForm.errors.currentCTC &&
                                    addApplicantForm.touched.currentCTC
                                      ? " is-invalid"
                                      : "")
                                  }
                                  value={addApplicantForm.values.currentCTC}
                                  onChange={addApplicantForm.handleChange}
                                />
                              </div>
                              <div className="invalid-feedback">
                                {addApplicantForm.errors.currentCTC &&
                                addApplicantForm.touched.currentCTC
                                  ? addApplicantForm.errors.currentCTC
                                  : null}
                              </div>
                            </div>
                            <div className="mb-4 col-md-6">
                              <label className="form-label">Expected CTC</label>
                              <div className="cover-form">
                                <div>
                                  <i
                                    className="fa fa-money"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                                <input
                                  type="number"
                                  name="expectedCTC"
                                  className={
                                    "form-control" +
                                    (addApplicantForm.errors.expectedCTC &&
                                    addApplicantForm.touched.expectedCTC
                                      ? " is-invalid"
                                      : "")
                                  }
                                  value={addApplicantForm.values.expectedCTC}
                                  onChange={addApplicantForm.handleChange}
                                />
                              </div>
                              <div className="invalid-feedback">
                                {addApplicantForm.errors.expectedCTC &&
                                addApplicantForm.touched.expectedCTC
                                  ? addApplicantForm.errors.expectedCTC
                                  : null}
                              </div>
                            </div>
                            <div className="mb-4 col-md-6">
                              <label className="form-label">
                                Overall Experience
                              </label>
                              <div className="cover-form">
                                <div>
                                  <i
                                    className="fa fa-user-o"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                                <select
                                  id="inputState"
                                  name="overallExperience"
                                  className={
                                    "default-select form-control wide" +
                                    (addApplicantForm.errors
                                      .overallExperience &&
                                    addApplicantForm.touched.overallExperience
                                      ? " is-invalid"
                                      : "")
                                  }
                                  value={
                                    addApplicantForm.values.overallExperience
                                  }
                                  onChange={addApplicantForm.handleChange}
                                >
                                  <option selected="">Choose...</option>
                                  <option>3</option>
                                  <option>4</option>
                                  <option>5.5</option>
                                </select>
                              </div>
                              <div className="invalid-feedback">
                                {addApplicantForm.errors.overallExperience &&
                                addApplicantForm.touched.overallExperience
                                  ? addApplicantForm.errors.overallExperience
                                  : null}
                              </div>
                            </div>
                            <div className="mb-4 col-md-6">
                              <label className="form-label">
                                Relevant Experience
                              </label>
                              <div className="cover-form">
                                <div>
                                  <i
                                    className="fa fa-user-o"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                                <select
                                  id="inputState"
                                  name="relevantExperience"
                                  className={
                                    "default-select form-control wide" +
                                    (addApplicantForm.errors
                                      .relevantExperience &&
                                    addApplicantForm.touched.relevantExperience
                                      ? " is-invalid"
                                      : "")
                                  }
                                  value={
                                    addApplicantForm.values.relevantExperience
                                  }
                                  onChange={addApplicantForm.handleChange}
                                >
                                  <option selected="">Choose...</option>
                                  <option>1.5</option>
                                  <option>2.5</option>
                                </select>
                              </div>
                              <div className="invalid-feedback">
                                {addApplicantForm.errors.relevantExperience &&
                                addApplicantForm.touched.relevantExperience
                                  ? addApplicantForm.errors.relevantExperience
                                  : null}
                              </div>
                            </div>
                            <div className="mb-4 col-md-12">
                              <label className="form-label">
                                Notice Period
                              </label>
                              <div className="cover-form">
                                <div>
                                  <i
                                    className="fa fa-user-o"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                                <select
                                  id="inputState"
                                  name="noticePeriod"
                                  className={
                                    "default-select form-control wide" +
                                    (addApplicantForm.errors.noticePeriod &&
                                    addApplicantForm.touched.noticePeriod
                                      ? " is-invalid"
                                      : "")
                                  }
                                  value={addApplicantForm.values.noticePeriod}
                                  onChange={addApplicantForm.handleChange}
                                >
                                  <option selected="">Choose...</option>
                                  <option>20Days(Negotiable to 10 days)</option>
                                  <option>30Days(Negotiable to 15 days)</option>
                                </select>
                              </div>
                              <div className="invalid-feedback">
                                {addApplicantForm.errors.noticePeriod &&
                                addApplicantForm.touched.noticePeriod
                                  ? addApplicantForm.errors.noticePeriod
                                  : null}
                              </div>
                            </div>
                            {/* <div className="mb-4 col-md-12">
                                                        <label className="form-label">Level</label>
                                                        <div className="check-leveloption">
                                                            <div className="inner">
                                                                <input type="radio" id="one" name="fav_language" value="ONE" />
                                                                <span>All Level</span>
                                                            </div>
                                                            <div className="inner">
                                                                <input type="radio" id="two" name="fav_language" value="TWO" />
                                                                <span>Beginner</span>
                                                            </div>
                                                            <div className="inner">
                                                                <input type="radio" id="three" name="fav_language" value="THREE" />
                                                                <span>Intermediate</span>
                                                            </div>
                                                            <div className="inner">
                                                                <input type="radio" id="three" name="fav_language" value="THREE" />
                                                                <span>Expert</span>
                                                            </div>
                                                        </div>
                                                    </div> */}
                          </div>
                          {/* <span className="tagtitle">Secondary contact detail</span>
                                                    <div className="row">
                                                        <div className="mb-4 col-md-6">
                                                            <label className="form-label">Mobile Number</label>
                                                            <div className="cover-form">
                                                                <div><i className="fa fa-money" aria-hidden="true"></i></div>
                                                                <input type="number" className="form-control" /></div>
                                                        </div>
                                                        <div className="mb-4 col-md-6">
                                                            <label className="form-label">Email</label>
                                                            <div className="cover-form">
                                                                <div><i className="fa fa-money" aria-hidden="true"></i></div>
                                                                <input type="email" className="form-control" /></div>
                                                        </div>
                                                    </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-xl-4">
                                    <div className="row addcourseform">
                                        <div className="col-xl-12">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="loadresumes"><div className="inner">
                                                        <img src="images/org-img/recruitment/upload.svg" /><span>
                                                            Upload Resume</span>
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <span className="tagtitle">Social Media Profile</span>
                                            <div className="mb-2 col-md-12">
                                                <label className="form-label">Select Platform</label>
                                                <div className="cover-form">
                                                    <div><i className="fa fa-bookmark-o" aria-hidden="true"></i></div>
                                                    <select id="inputState" className="default-select form-control wide">
                                                        <option selected="">Choose...</option>
                                                        <option>Facebook</option>
                                                        <option>Instagram</option>
                                                        <option>Youtube</option>
                                                    </select></div>
                                            </div>
                                            <div className="mb-4 col-md-12">
                                                <div className="cover-form">
                                                    <div><i className="fa fa-money" aria-hidden="true"></i></div>
                                                    <input type="text" className="form-control" placeholder="Enter Url" /></div>
                                            </div>
                                            <div className="divider">
                                                <hr /><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus-square-dotted" viewBox="0 0 16 16">
                                                    <path d="M2.5 0q-.25 0-.487.048l.194.98A1.5 1.5 0 0 1 2.5 1h.458V0zm2.292 0h-.917v1h.917zm1.833 0h-.917v1h.917zm1.833 0h-.916v1h.916zm1.834 0h-.917v1h.917zm1.833 0h-.917v1h.917zM13.5 0h-.458v1h.458q.151 0 .293.029l.194-.981A2.5 2.5 0 0 0 13.5 0m2.079 1.11a2.5 2.5 0 0 0-.69-.689l-.556.831q.248.167.415.415l.83-.556zM1.11.421a2.5 2.5 0 0 0-.689.69l.831.556c.11-.164.251-.305.415-.415zM16 2.5q0-.25-.048-.487l-.98.194q.027.141.028.293v.458h1zM.048 2.013A2.5 2.5 0 0 0 0 2.5v.458h1V2.5q0-.151.029-.293zM0 3.875v.917h1v-.917zm16 .917v-.917h-1v.917zM0 5.708v.917h1v-.917zm16 .917v-.917h-1v.917zM0 7.542v.916h1v-.916zm15 .916h1v-.916h-1zM0 9.375v.917h1v-.917zm16 .917v-.917h-1v.917zm-16 .916v.917h1v-.917zm16 .917v-.917h-1v.917zm-16 .917v.458q0 .25.048.487l.98-.194A1.5 1.5 0 0 1 1 13.5v-.458zm16 .458v-.458h-1v.458q0 .151-.029.293l.981.194Q16 13.75 16 13.5M.421 14.89c.183.272.417.506.69.689l.556-.831a1.5 1.5 0 0 1-.415-.415zm14.469.689c.272-.183.506-.417.689-.69l-.831-.556c-.11.164-.251.305-.415.415l.556.83zm-12.877.373Q2.25 16 2.5 16h.458v-1H2.5q-.151 0-.293-.029zM13.5 16q.25 0 .487-.048l-.194-.98A1.5 1.5 0 0 1 13.5 15h-.458v1zm-9.625 0h.917v-1h-.917zm1.833 0h.917v-1h-.917zm1.834-1v1h.916v-1zm1.833 1h.917v-1h-.917zm1.833 0h.917v-1h-.917zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3z" />
                                                </svg></div>
                                            <div className="mb-2 col-md-12">
                                            <label className="form-label">Added Social media Platform</label>
                                            <ul className="added-socialmedia">
                                                <li><img src="images/org-img/recruitment/facebook.svg"/>facebook.com/username<i className="fa fa-trash-o"></i></li>
                                                <li><img src="images/org-img/recruitment/insta.svg"/>instagram.com/username<i className="fa fa-trash-o"></i></li>
                                                <li><img src="images/org-img/recruitment/linkidin.svg"/>linkedin.com/username<i className="fa fa-trash-o"></i></li>
                                            </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                  <div className="col-md-12">
                    <div className="btns-grp">
                      <button className="savebtn-click" type="submit">
                        Save
                      </button>
                      <button
                        className="publish-click"
                        onClick={() => addMoreDetail(1)}
                      >
                        Add More Detail
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            )}

            {uploadResume && !socialMedia && (
              <div className="row">
                <div className="col-xl-10">
                  <div className="col-xl-12">
                    <div className="supp-req">
                      <div className="addcourseform">
                        <form>
                          <span className="tagtitle">
                            Secondary contact detail
                          </span>
                          <div className="row">
                            <div className="mb-4 col-md-6">
                              <label className="form-label">
                                Mobile Number
                              </label>
                              <div className="cover-form">
                                <div>
                                  <i
                                    className="fa fa-money"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                                <input type="number" className="form-control" />
                              </div>
                            </div>
                            <div className="mb-4 col-md-6">
                              <label className="form-label">Email</label>
                              <div className="cover-form">
                                <div>
                                  <i
                                    className="fa fa-money"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                                <input type="email" className="form-control" />
                              </div>
                            </div>

                            <div className="loadresumes">
                              <div className="inner">
                                <img src="images/org-img/recruitment/upload.svg" />
                                <span>Upload Resume</span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="btns-grp">
                    <button className="savebtn-click">Save</button>
                    <button
                      className="publish-click"
                      onClick={() => addMoreDetail(2)}
                    >
                      Add More Detail
                    </button>
                  </div>
                </div>
              </div>
            )}

            {socialMedia && (
              <div className="row">
                <div className="col-xl-10">
                  <div className="col-xl-12">
                    <div className="supp-req">
                      <div className="addcourseform">
                        <div className="col-xl-12">
                          <div className="row addcourseform">
                            <div className="col-xl-12">
                              <span className="tagtitle">
                                Social Media Profile
                              </span>
                              <div className="mb-2 col-md-12">
                                <label className="form-label">
                                  Select Platform
                                </label>
                                <div className="cover-form">
                                  <div>
                                    <i
                                      className="fa fa-bookmark-o"
                                      aria-hidden="true"
                                    ></i>
                                  </div>
                                  <select
                                    id="inputState"
                                    className="default-select form-control wide"
                                  >
                                    <option selected="">Choose...</option>
                                    <option>Facebook</option>
                                    <option>Instagram</option>
                                    <option>Youtube</option>
                                  </select>
                                </div>
                              </div>
                              <div className="mb-4 col-md-12">
                                <div className="cover-form">
                                  <div>
                                    <i
                                      className="fa fa-money"
                                      aria-hidden="true"
                                    ></i>
                                  </div>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Url"
                                  />
                                </div>
                              </div>
                              <div className="divider">
                                <hr />
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-plus-square-dotted"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M2.5 0q-.25 0-.487.048l.194.98A1.5 1.5 0 0 1 2.5 1h.458V0zm2.292 0h-.917v1h.917zm1.833 0h-.917v1h.917zm1.833 0h-.916v1h.916zm1.834 0h-.917v1h.917zm1.833 0h-.917v1h.917zM13.5 0h-.458v1h.458q.151 0 .293.029l.194-.981A2.5 2.5 0 0 0 13.5 0m2.079 1.11a2.5 2.5 0 0 0-.69-.689l-.556.831q.248.167.415.415l.83-.556zM1.11.421a2.5 2.5 0 0 0-.689.69l.831.556c.11-.164.251-.305.415-.415zM16 2.5q0-.25-.048-.487l-.98.194q.027.141.028.293v.458h1zM.048 2.013A2.5 2.5 0 0 0 0 2.5v.458h1V2.5q0-.151.029-.293zM0 3.875v.917h1v-.917zm16 .917v-.917h-1v.917zM0 5.708v.917h1v-.917zm16 .917v-.917h-1v.917zM0 7.542v.916h1v-.916zm15 .916h1v-.916h-1zM0 9.375v.917h1v-.917zm16 .917v-.917h-1v.917zm-16 .916v.917h1v-.917zm16 .917v-.917h-1v.917zm-16 .917v.458q0 .25.048.487l.98-.194A1.5 1.5 0 0 1 1 13.5v-.458zm16 .458v-.458h-1v.458q0 .151-.029.293l.981.194Q16 13.75 16 13.5M.421 14.89c.183.272.417.506.69.689l.556-.831a1.5 1.5 0 0 1-.415-.415zm14.469.689c.272-.183.506-.417.689-.69l-.831-.556c-.11.164-.251.305-.415.415l.556.83zm-12.877.373Q2.25 16 2.5 16h.458v-1H2.5q-.151 0-.293-.029zM13.5 16q.25 0 .487-.048l-.194-.98A1.5 1.5 0 0 1 13.5 15h-.458v1zm-9.625 0h.917v-1h-.917zm1.833 0h.917v-1h-.917zm1.834-1v1h.916v-1zm1.833 1h.917v-1h-.917zm1.833 0h.917v-1h-.917zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3z" />
                                </svg>
                              </div>
                              <div className="mb-2 col-md-12">
                                <label className="form-label">
                                  Added Social media Platform
                                </label>
                                <ul className="added-socialmedia">
                                  <li>
                                    <img src="images/org-img/recruitment/facebook.svg" />
                                    facebook.com/username
                                    <i className="fa fa-trash-o"></i>
                                  </li>
                                  <li>
                                    <img src="images/org-img/recruitment/insta.svg" />
                                    instagram.com/username
                                    <i className="fa fa-trash-o"></i>
                                  </li>
                                  <li>
                                    <img src="images/org-img/recruitment/linkidin.svg" />
                                    linkedin.com/username
                                    <i className="fa fa-trash-o"></i>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="btns-grp">
                    <button className="savebtn-click">Save</button>
                    <button
                      className="publish-click"
                      onClick={() => addMoreDetail(2)}
                    >
                      Save and Exit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="modal fade" id="contact-manager">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title m-auto">
                Contact Your Reporting Manager htmlFor Any Leave Clarifications
              </h5>
            </div>
            <div className="modal-body text-center">
              <form>
                <div className="form-group text-left">
                  <label>Repoting Manager</label>
                  <select className="default-select form-control wide mb-3">
                    <option selected disabled>
                      Select reporting manager
                    </option>
                    <option>Arun Mishra</option>
                    <option>Pragya Tiwari</option>
                    <option>Alisha Goyal</option>
                  </select>
                </div>
                <div className="form-group text-left">
                  <label className="mt-3">Reason</label>
                  <textarea
                    rows="4"
                    cols="1"
                    className="form-control"
                  ></textarea>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger light"
                data-bs-dismiss="modal"
              >
                Decline
              </button>
              <button type="button" className="btn btn-primary">
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
// }
export default AddApplicant;
